<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <ik-data-table
      v-if="!loading"
      :entity-name="entityName"
      :fixed-filter="filter"
      :icon="'mdi-heart'"
      :model="Attribute"
    >
      <template #navigation>
        <v-btn
          class="mr-4 rounded"
          height="36px"
          icon
          outlined
          tile
          width="36px"
          @click="$router.back()"
        >
          <v-icon size="24">
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
      <template #footer>
        <v-btn
          class="ml-2"
          elevation="0"
          outlined
          style="background: white"
          @click="showThisGroupAttribute = true"
        >
          {{ $t('changeSort') }}
        </v-btn>
      </template>
    </ik-data-table>
    <v-dialog
      v-model="showThisGroupAttribute"
      max-width="600px"
    >
      <v-card
        min-height="600px"
      >
        <sort-fragment
          v-if="showThisGroupAttribute"
          :initial-list="attributeList"
          item-sort="value"
          @close="showThisGroupAttribute=false"
          @save="updateSort"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Attribute from '@/model/dish/Attribute'
  import SortFragment from '@/views/AadenPages/dishes/dish/widget/SortFragment'
  import { IkDataTable } from 'metaflow-js'
  import IKUtils from 'innerken-js-utils'
  import AttributeGroup from '@/model/dish/AttributeGroup'
  import { showSuccessMessage } from '@/common/utils'

  export default {
    name: 'AttributePage',
    components: {
      SortFragment,
      IkDataTable,
    },
    props: {
      groupId: {},
    },
    data: function () {
      return {

        attributeList: [],
        showThisGroupAttribute: null,
        currentAttributeGroup: null,
        Attribute,
        loading: true,
        filter: null,
      }
    },
    computed: {
      entityName () {
        return this.$t('attribute') + (this.currentAttributeGroup ? ' · ' + this.currentAttributeGroup.name : '')
      },
    },
    async mounted () {
      if (this.groupId) {
        this.filter = { attributeGroupId: parseInt(this.groupId) }
        this.currentAttributeGroup =
          (await AttributeGroup.getList(true)).find(it => it.id === parseInt(this.groupId))
        this.attributeList =
          (await Attribute.getList(true))
            .filter(it => it.attributeGroupId === parseInt(this.groupId))
      }
      this.loading = false
    },
    methods: {
      async updateSort (newList) {
        IKUtils.showLoading()
        const reqs = newList.map(async (it, i) => {
          it.value = i + 1
          return await this.Attribute.edit(it)
        })
        await Promise.allSettled(reqs)
        showSuccessMessage()
        this.showThisGroupAttribute = false
      },
    },
  }
</script>

<style scoped>

</style>


